import { H } from "../../../Component";

interface TableIconProps { }

export default (props: TableIconProps, tsx: H) => (
    <svg
        height="16px"
        width="16px"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 16 16"
    >
        <path
            d="M16 15H0V1h16zM5 9H1v2h4zm1-3v2h4V6zM5 6H1v2h4zm5 8v-2H6v2zm0-5H6v2h4zm1-3v2h4V6zm-6 6H1v2h4zm6-1h4V9h-4zm0 3h4v-2h-4zm4-12H1v3h14z"
        />
    </svg>
);
